export default {
  PER_100_LITERS: "100 L",
  PER_HECTARE: "Ha"
};
